<!-- <template>
  <router-view />
</template> -->
<template>
  <a-config-provider :locale="zh_CN">
    <div id="app">
      <router-view></router-view>
    </div>
  </a-config-provider>
</template>

<script>
import zh_CN from "ant-design-vue/lib/locale/zh_CN";
export default {
  name: "App",
  data() {
    return {
      zh_CN,
    };
  },
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body {
  margin: 0;
}
.intermediate {
  // width: 1920px;
  min-width: 1024px;
  min-height: calc(100vh - 354px);
  background-color: #fafafa;
}
.bgImg {
  background-repeat: no-repeat;
  background-position: center;
  // background-attachment: fixed;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
}
</style>
